module.exports = __webpack_public_path__ + "static/media/surfair_card_4.2cdcb88f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/surfair_card_4.png
// module id = 521
// module chunks = 0